import * as Yup from "yup";

import ComposePage from "./ComposePage";
import ConfirmPage from "./ConfirmPage";
import ConnectConfirmPage from "./ConnectConfirmPage";
import ConnectPage from "./ConnectPage";
import PreviewPage from "./PreviewPage";
import ProfilesPage from "./ProfilesPage";

export const pageData = (admin) => {
  return {
    connect: {
      next: "connect-confirm",
      showSubmit: false,
      showClose: true,
      title: {
        text: "Let's connect",
        fontWeight: "700",
        variant: "h4",
      },
      component: ConnectPage,
      props: ["loginUrls"],
    },
    "connect-confirm": {
      previous: "profiles",
      next: "compose",
      title: {
        text: "Welcome",
        fontWeight: "100",
        variant: "h5",
      },
      submitText: "Continue",
      showBackButton: false,
      backText: "Profiles",
      showSubmit: true,
      excludeFromBreadcrumbs: true,
      component: ConnectConfirmPage,
      props: ["profile"],
    },
    profiles: {
      next: "compose",
      title: {
        text: "Manage your Profile",
        fontWeight: "100",
        variant: "h5",
      },
      submitText: "Next",
      showBackButton: false,
      showSubmit: true,
      excludeFromBreadcrumbs: true,
      component: ProfilesPage,
      props: ["profiles"],
    },
    compose: {
      previous: "profiles",
      next: "preview",
      submitText: "Preview",
      showSubmit: true,
      showReset: admin ?? false,
      showAccountMenu: true,
      showBackButton: true,
      validationSchema: Yup.object({
        subject: Yup.string()
          .max(100, "Must be 100 characters or less")
          .required("Required"),
        body: Yup.string()
          .min(5, "Must be 5 characters or more")
          .max(10000, "Must be 10000 characters or less")
          .required("Required"),
      }),
      component: ComposePage,
      props: ["profile"],
    },
    preview: {
      previous: "compose",
      next: "confirm",
      backText: "Edit",
      showBreadcrumbs: false,
      showBackButton: true,
      submitText: "Send",
      showSubmit: true,
      component: PreviewPage,
      props: ["profile"],
    },
    confirm: {
      previous: "preview",
      showBreadcrumbs: false,
      submitText: "Ok",
      showSubmit: true,
      component: ConfirmPage,
      props: ["profile"],
    },
  };
};
